export default __webpack_public_path__ + "static/media/logo-sm.6915356c.svg";